module.exports = __webpack_public_path__ + "img/occupation_story_card1.dc067c9f.svg";